export function truncate(input: string, length = 40) {
  if (input.length > length) {
    return `${input.substring(0, length)}...`
  }

  return input
}
